import { api } from 'api';

/**
 * add
 * @param {*} data
 * @returns
 */
export const addCategory = (data) => {
  return api.call('vehicle_category.add', data);
};

/**
 * update
 * @param {*} data
 * @returns
 */
export const updateCategory = (data) => {
  return api.call('vehicle_category.update', data);
};
